import React from 'react';
import './Admissions.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import admissionsData from '../../data/admissionsData';

const Admissions = () => {
  const { director } = admissionsData;

  return (
    <div className="admissions-page" id="admissions-page-unique">
      <Navbar />
      
      <div className="admissions-container" id="admissions-container-unique">
        
        {/* Admissions Director Section */}
        <div className="admissions-section" id="admissions-director-section-unique">
          <h2>Director of Admissions</h2>
          <div className="director-card" id="admissions-director-card-unique">
            <div className="director-image" id="admissions-director-image-unique">
              <img src={director.image} alt={director.name} />
            </div>
            <div className="director-info" id="admissions-director-info-unique">
              <h3>{director.name}</h3>
              <p className="director-qualifications">{director.qualifications}</p>
              <p className="director-position">{director.position}</p>
              <p className="director-department">{director.department}</p>
              <div className="director-contact" id="admissions-director-contact-unique">
                <p><i className="fas fa-envelope"></i> {director.email}</p>
                <p><i className="fas fa-building"></i> {director.office}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Admissions;